import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionReset } from '../types';

const reset: IActionReset = action(state => {
  const { events, details, pagination } = initStore;

  state.events = events;
  state.details = details;
  state.pagination = pagination;
});

export default reset;
